import { Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ErrorHandlerService } from '@examdojo/core/error-handling';
import { EMPTY, startWith, switchMap, tap } from 'rxjs';
import { ExamdojoPlatformService } from '../../../shared/platform.service';
import { StudentClassService } from '../student-class/student-class.service';
import { StudentClassStore } from '../student-class/student-class.store';

@Injectable()
export class FetchStudentClassesEffect {
  constructor(
    private readonly studentClassService: StudentClassService,
    private readonly studentClassStore: StudentClassStore,
    private readonly errorHandlerService: ErrorHandlerService,
    private readonly platformService: ExamdojoPlatformService,
  ) {
    this.platformService.trigger$
      .pipe(
        startWith(null),
        switchMap(() =>
          this.studentClassService.fetchAllClasses().pipe(
            tap(() => this.studentClassStore.updateProp('initialized', true)),
            this.errorHandlerService.catchHttpErrors(() => EMPTY),
          ),
        ),
        takeUntilDestroyed(),
      )
      .subscribe();
  }
}
